<div class="invitee">
  <span class="sr-only" i18n="sr-only@@employment.invitePlaceholder.email">E-Mail:</span>
  <span class="icon icon-mail"></span>
  <a class="email-link"
  href="mailto:{{memberRelation.member.emailAddress}}">{{ memberRelation.member.emailAddress }}</a>
</div>
@if (memberRelation.relation) {
  <div class="actions">
    @if (memberRelation.relation.memberId !== '') {
      <button (click)="clearPlaceholder(memberRelation)" class="link"
        i18n="@@employment.invitePlaceholder.btnRemove">Entfernen
    </button>
    }
    <button (click)="resendInvitation(memberRelation.member)" [disabled]="sending" class="button"
      i18n="@@employment.invitePlaceholder.btnResend">Einladung erneut senden
    </button>
  </div>
}
